<template lang="html">
  <div id="admin">
    <div id="header">

      <div class="container">

        <div class="row">
          <div class="col-6 headline">
            <b>TMABS Buchungen</b>
          </div>
          <div class="col-6 text-right">
            <button class="btn btn-danger btn-sm" @click="logout">Abmelden</button>
          </div>
      </div>

      </div>


  </div>
    <vue-snotify></vue-snotify>
    <router-view></router-view>
  </div>
</template>

<script>
import store from '@/state/store'

export default {
  name: 'AdminOutlet',
  beforeRouteEnter (to, from, next) {
    if(!store.state.auth.token){
      next('/login')
    } else {
      next()
    }
  },
  methods: {
    async logout () {
      await this.$store.dispatch('auth/LOGOUT')
      this.$router.push('/login')
    }
  }
}
</script>

<style lang="scss">
@import "~vue-snotify/styles/material";
body{
  background: #f4f4f4;
}
#header {
  width:100%;
  background-color: #FFF;
  color:#333;
  border-bottom: 2px solid rgb(0, 145, 209);
  box-shadow: 0px 1px 2px 1px rgba(0,0,0,0.2);
  margin-bottom: 40px;
}

#header .row {
  padding:10px;
}

#header .headline {
  font-size:20pt;
}
</style>



// WEBPACK FOOTER //
// src/views/admin/AdminOutlet.vue